import { z } from "zod";

import { dateSchema } from "./utils";

const sportNewsArticleBaseSchema = z.object({
  id: z.coerce.string(),
  title: z.string(),
  summary: z.string().catch(""),
  thumbnail_url: z.string().nullish().catch(null),
  header_image_url: z.string().nullish().catch(null),
  author: z.string().catch(""),
  author_handle: z.string().catch(""),
  author_avatar_url: z.string().nullish().catch(null),
  created_at: dateSchema.optional().catch(undefined),
  status_id: z.union([z.number(), z.string()]).nullish().catch(null),
  truth_count: z.number().catch(0),
  comment_count: z.number().catch(0),
  avatars: z.array(z.string()).catch([]),
});

const stringifyIds = <
  T extends { id: number | string; status_id?: number | string | null },
>(
  data: T,
) => ({
  ...data,
  id: String(data.id),
  status_id: data.status_id == null ? data.status_id : String(data.status_id),
});

const sportNewsArticleSchema =
  sportNewsArticleBaseSchema.transform(stringifyIds);

const sportNewsArticleDetailSchema = sportNewsArticleBaseSchema
  .extend({
    body: z.string().catch(""),
    source_url: z.string().nullish().catch(null),
  })
  .transform(stringifyIds);

type SportNewsArticle = z.infer<typeof sportNewsArticleSchema>;
type SportNewsArticleDetail = z.infer<typeof sportNewsArticleDetailSchema>;

export {
  sportNewsArticleSchema,
  sportNewsArticleDetailSchema,
  type SportNewsArticle,
  type SportNewsArticleDetail,
};
